var map = {
	"./frame-creative.png": 2052,
	"./frame-img.png": 2053,
	"./frame-math.png": 2054,
	"./frame-pyt-nosnake.png": 2055,
	"./frame-pyt.png": 2056,
	"./frame.svg": 2057,
	"./start-bg.png": 1699
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2051;